module.exports = __webpack_public_path__ + "img/map.dd3e3fb0.png";